module.exports = __webpack_public_path__ + "system/img/exoneration.f2afe3da.png";